import { HOST_STATES, type HostStateCode } from '@schemas'
import { cn } from '@/lib/utils'

export function HostStateSelect({
  id,
  value,
  onChange,
  disabled,
  className,
}: {
  id?: string
  value: HostStateCode | null | undefined
  onChange: (value: HostStateCode | null) => void
  disabled?: boolean
  className?: string
}) {
  return (
    <select
      id={id}
      aria-label="Host state"
      value={value ?? ''}
      disabled={disabled}
      onChange={event =>
        onChange(event.target.value ? (event.target.value as HostStateCode) : null)
      }
      className={cn(
        'h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus-visible:outline-2 focus-visible:outline-ring',
        className
      )}
    >
      <option value="">Location not set</option>
      {HOST_STATES.map(state => (
        <option key={state} value={state}>
          {state}
        </option>
      ))}
    </select>
  )
}
